import { Component, OnInit, ViewEncapsulation, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { PayrollDataActivityReportService } from './payrollDataActivityReport.service';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';
import { OrderPipe } from 'ngx-order-pipe';

@Component({
    moduleId: module.id,
    templateUrl: './payrollDataActivityReport.html',
    styleUrls: ['./payrollDataActivityReport.component.css']
})
export class PayrollDataActivityReportComponent implements OnInit {
    pdaReportForm: FormGroup;
    private controlGroupControl: FormControl;
    private yearControl: FormControl;
    selectedYear: string;
    selectedYears: string[];
    selectedControlGroups: any[];
    dataLoaded: boolean;
    order: string = 'key';
    reverse: boolean = false;
    errorMessage: string;
    count13Weeks: string;
    count26Weeks: string;
    count47Weeks: string;
    count52Weeks: string;
    downloadPdfInProgress: boolean = false;
    downloadExcelInProgress: boolean = false;

    @ViewChild('topScroll') topScroll: ElementRef;
    @ViewChild('bottomScroll') bottomScroll: ElementRef;

    workDetails: Array<any> = [];
    public loading = false;
    public rows: Array<any> = [];
    public page = 1;
    public itemsPerPage = 10;
    public maxSize = 5;
    public numPages = 1;
    public length = 0;

    optionsModel: number[];
    myOptionsYear: any[];
    myOptionsCG: any = [];
    userData: any;
    paginationData: any = {};
    payrollData: any = [];
    searchValue: any;
    cgDropdownSettings = {
        singleSelection: false,
        text: 'Select Controlled Group',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        enableSearchFilter: true,
        classes: 'myclass custom-class',
        badgeShowLimit: 2
    };
    selectedCgValues: any[]
    showfiltererror: boolean = false;
    downloadpdf: any;
    downloadexcel: any;
    selectedYearValues: any = [];
    yearDropdownSettings: any = {
        singleSelection: false,
        text: 'Select Year',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        enableSearchFilter: true,
        classes: 'myclass custom-class',
        badgeShowLimit: 3
    };
    topScrollWidth: number = 2300;
    isfilterloaded: boolean = false;
    headerData = [
        { name: "SSN", key: "ssn" },
        { name: "First Name", key: "firstName"},
        { name: "Last Name", key: "lastName" },
        { name: "EIN", key: "ein" },
        { name: "Year", key: "taxYear"},
        { name: "Production Company", key: "productionCompany" },
        { name: "Production Show", key: "project" },
        { name: "Payroll Source", key: "source" },
        { name: "Hire Date", key: "hireDate" },
        { name: "Last Worked Date", key: "lastDateWorked" },
        { name: "ACA Employment Status", key: "employmentStatus" },
        { name: "Union Status", key: "unionHours" },
        { name: "Union Name", key: "unionName" },
        { name: "Jan", key: "jan" },
        { name: "Feb", key: "feb" },
        { name: "Mar", key: "mar" },
        { name: "Apr", key: "apr" },
        { name: "May", key: "may" },
        { name: "Jun", key: "jun" },
        { name: "Jul", key: "jul" },
        { name: "Aug", key: "aug" },
        { name: "Sep", key: "sep" },
        { name: "Oct", key: "oct" },
        { name: "Nov", key: "nov" },
        { name: "Dec", key: "dec" }
    ]
    headername: string;
    constructor(private orderPipe: OrderPipe, private _pdareportsrv: PayrollDataActivityReportService) {
        this.userData = JSON.parse(localStorage.getItem('token'));
        this.payrollData = orderPipe.transform(this.headerData, 'key');
    }

    ngOnInit(): void {

        if (localStorage.getItem('storedData')) {
            this.onloadData();
        }
        this.myOptionsYear = [];
        this.myOptionsCG = [];

        this.controlGroupControl = new FormControl('', Validators.required);
        this.yearControl = new FormControl('-1');
        this.pdaReportForm = new FormGroup(
            {
                controlGroup: this.controlGroupControl,
                yearControl: this.yearControl
            }
        );
        this.setFilterData();
        this.count13Weeks = '0';
        this.count26Weeks = '0';
        this.count47Weeks = '0';
        this.count52Weeks = '0';
        this.dataLoaded = false;
    }

    setOrder(value: string) {
        if (this.order === value) {
            this.reverse = !this.reverse;
        }
        this.order = value;
    }

    onloadData(): void {
        const ssnData = JSON.parse(localStorage.getItem('storedData'));
        this.loading = true;
        this._pdareportsrv.getSSnData(ssnData).subscribe(workdetails => {
            this.loading = false;
            this.dataLoaded = true;
            this.payrollData = workdetails;
        },
            error => this.errorMessage = <any>error);
    }
    reset(): void {
        this.selectedYears = [];
        this.dataLoaded = false;
        this.searchValue = '';
        this.showfiltererror = false;
        this.selectedYearValues = [];
        if(this.userData.principal.roles[0] !== 'User' || this.userData.principal.controlGroups.length > 1){
            this.selectedControlGroups = [];
            this.selectedCgValues = [];
        }
    }
    getFilterValues(): any {
        let year = this.selectedYears;
        if (year === undefined) {
            year = [];
            year[0] = '\'\'';
            this.selectedYears = [];
        }
        if (year !== undefined && year.length <= 0) {
            year[0] = '\'\'';
            this.selectedYears = [];
        }

        let cg = this.selectedControlGroups;
        if (cg === undefined) {
            cg = [];
            cg[0] = '\'\'';
            this.selectedControlGroups = [];
        }
        if (cg !== undefined && cg.length <= 0) {
            cg[0] = '\'\'';
            this.selectedControlGroups = [];
        }
        const filterCriteria: any = {
            selectedYear: year.join(':'), selectedControlGroup: cg.join(':'),
        };
        return filterCriteria;
    }

    onSearch() {
        this.payrollData = [];
        this.paginationData = {};
        this.Search(1, this.searchValue);
    }

    Search(page = 1, searchKey = (this.searchValue || '')): void {

        let filterCriteria = {
            taxYear: this.selectedYears || [],
            controlGroup: this.selectedControlGroups || [],
            searchKey,
            pagination: {
                pageNo: page,
                pageSize: 10
            }
        }
        if (filterCriteria.controlGroup.length === 0) {
            this.showfiltererror = true;
            return
        }
        this.isfilterloaded = true;
        this.showfiltererror = false;
        this.loading = true;
        this._pdareportsrv.getPayrollActivityReportData(filterCriteria).subscribe((data: any) => {
            this.payrollData = data.payrollDataActivityVo;
            this.paginationData = data.pagination;
            this.loading = false;
            this.isfilterloaded = false;
            this.dataLoaded = true;
            // this.topScrollWidth = this.bottomScroll.nativeElement.scrollWidth+200;

        },
            error => this.errorMessage = <any>error);
    }

    downloadPdf(): void {
        this.downloadpdf = true;
        const filterCriteria = this.getFilterValues();
        this._pdareportsrv.downloadPDFReport(filterCriteria).subscribe((data: any) => {
            this.downloadpdf = false;
            this.loading = false;
        }, (err: any) => (this.downloadpdf = false))
    }

    downloadExcel(): void {
        this.downloadexcel = true;
        const filterCriteria = this.getFilterValues();
        this._pdareportsrv.downloadExcelReport(filterCriteria).subscribe((data: any) => {
            this.downloadexcel = false
            this.loading = false;
        }, (err: any) => (this.downloadexcel = false))
    }

    onChangeTable(page: any): any {
        this.Search(page.page, this.searchValue)
    }

    ngOnDestroy() {
        localStorage.removeItem('storedData')
    }

    searchTable(searchValue: any) {
        this.Search()
    }

    onChangeControlledGroup() {
        this.selectedControlGroups = this.selectedCgValues ? this.selectedCgValues.map((item: any) => item.itemName) : [];
    }
    onChangeYear() {
        this.selectedYears = this.selectedYearValues ? this.selectedYearValues.map((item: any) => item.itemName) : [];
    }

    arescrolling = 0;
    scroller(from: any, to: any) {
        if (this.arescrolling) return; // avoid potential recursion/inefficiency
        this.arescrolling = 1;
        // set the other div's scroll position equal to ours
        // this.el;
        // debugger;
        from.scrollLeft = to.scrollLeft;
        // document.getElementById(to).scrollLeft =
        //     document.getElementById(from).scrollLeft;
        this.arescrolling = 0;
    }
    setFilterData(){
        this._pdareportsrv.getReportData().subscribe(data => {
            this.myOptionsYear = data.WorkYears.map((element:any) => {return {id:element,itemName:element}});
            if(this.userData.principal.roles[0] == 'User'){
                if(this.userData.principal.controlGroups.length == 1){
                    this.cgDropdownSettings['disabled'] = true;
                    this.cgDropdownSettings['singleSelection'] = true;
                    this.cgDropdownSettings = Object.assign({}, this.cgDropdownSettings);
                    this.selectedCgValues = [{id:this.userData.principal.controlGroups[0], itemName:this.userData.principal.controlGroups[0]}]
                    this.selectedControlGroups = [this.userData.principal.controlGroups[0]]
                }else{
                    this.myOptionsCG = this.userData.principal.controlGroups.filter((val:any) => data.ControlGroups.includes(val)).map((element:any) => {return {id:element,itemName:element}});
                }
            }else{
                this.myOptionsCG = data.ControlGroups.map((element:any) => {return {id:element,itemName:element}});
            }
        },
            error => this.errorMessage = <any>error);
    }
}



// WEBPACK FOOTER //
// ./src/app/PayrollDataActivityreport/payrollDataActivityReport.Component.ts